import { render, staticRenderFns } from "./CommentMessage.vue?vue&type=template&id=46dc20f0"
import script from "./CommentMessage.vue?vue&type=script&lang=js"
export * from "./CommentMessage.vue?vue&type=script&lang=js"
import style0 from "./CommentMessage.vue?vue&type=style&index=0&id=46dc20f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports